var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#DCF0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3 11C14.3 11.5304 14.1104 12.0391 13.7728 12.4142C13.4352 12.7893 12.9774 13 12.5 13C12.0226 13 11.5648 12.7893 11.2272 12.4142C10.8897 12.0391 10.7 11.5304 10.7 11C10.7 10.4696 10.8897 9.96086 11.2272 9.58579C11.5648 9.21071 12.0226 9 12.5 9C12.9774 9 13.4352 9.21071 13.7728 9.58579C14.1104 9.96086 14.3 10.4696 14.3 11Z",
    stroke: "#001F3B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11.2C17 16.1518 12.5 19 12.5 19C12.5 19 8 16.1518 8 11.2C8 9.82087 8.47411 8.49823 9.31802 7.52304C10.1619 6.54786 11.3065 6 12.5 6C13.6935 6 14.8381 6.54786 15.682 7.52304C16.5259 8.49823 17 9.82087 17 11.2Z",
    stroke: "#001F3B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCLocation);
export default __webpack_public_path__ + "static/media/c-location.c28d12dee43f448fb4fc15792fc304b6.svg";
export { ForwardRef as ReactComponent };